import salesforceCrmReadmeMarkdown from '@/assets/Artifacts/README.md?raw'
import { buildAppPublicUrl } from '@/config/env/appOrigin.js'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from './nexusIntegrationsDemo.js'
import { buildFileWriteNarration, buildStepNarration } from './stepNarrationCopy.js'


/** Demo copy and trace payloads for the Salesforce CRM integration API thread. */

export const ZOHO_CRM_INTEGRATION_USER_PROMPT =
  'Create an API connecting the new website with Salesforce CRM'

export const ZOHO_CRM_INTEGRATION_THOUGHT_DETAILS = [
  `Let me build a comprehensive Salesforce CRM integration API with FastAPI. I'll create:

A FastAPI backend with Salesforce OAuth2 authentication, endpoints for syncing leads, contacts, opportunities, and products, plus webhook handlers for incoming CRM events`,
  `Key endpoints covering the OAuth flow, lead and contact creation, opportunity management from orders, product catalog sync, webhook ingestion, and Platform Event triggers`,
  `Building the API structure... Writing the integration code...`,
  `Perfect — that's a clean scope. I'll build a full FastAPI integration layer covering all three data domains. Let me put this together now.`,
]

export const ZOHO_CRM_INTEGRATION_INTRO_MARKDOWN =
  "Let me build a comprehensive **Salesforce CRM** integration API with FastAPI. I'll create a FastAPI backend with Salesforce OAuth2 authentication, endpoints for syncing leads, contacts, opportunities, and products, plus webhook handlers for incoming CRM events."

export const ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN =
  "I'll scaffold the project structure under `salesforce-integration/` and write the integration layer now."

export const CRM_PROJECT_ROOT = '/DOSense/agent/home/salesforce-integration'
export const SALESFORCE_AUTH_CALLBACK_URL = buildAppPublicUrl('/api/v1/salesforce/auth/callback')

/** @param {string} relPath @param {string} content @param {number} [durationMs] @param {string} [stepNarration] @param {string} [nextRelPath] @param {number} [narrationIndex] */

export function writeStep(relPath, content, durationMs = 2800, stepNarration, nextRelPath, narrationIndex = 0) {
  return {
    durationMs,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: `${CRM_PROJECT_ROOT}/${relPath}`,
      content,
    },
    result: { ok: true },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: stepNarration ?? buildFileWriteNarration(relPath, nextRelPath, narrationIndex),
  }
}
